/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useMemo, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { VisualizationTableColumn, VisualizationValueType } from "./type";
import { Table } from "../Table";

type TabTableProps = {
  dataSource: any[];
  dataDict: any[];
  height?: number | string;
};

export const TabTable: FC<TabTableProps> = ({
  dataSource,
  dataDict,
  height,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const columns = useMemo(() => {
    return Object.entries(dataSource?.[0] || {}).map(([key, value]) => {
      let type = typeof value;

      if (!!Number(`${value}`.replaceAll(",", ""))) type = "number";

      const label = dataDict.find((d) => d.attribute === key)?.label;

      return {
        key,
        type: type as VisualizationValueType,
        label: label === "-" || !label ? key : label,
      } as VisualizationTableColumn;
    });
  }, [dataSource]);

  function getTextWidth(text: string) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (!context) return;
    context.font = "THSarabunPSK";
    const width = context.measureText(text).width;
    const formattedWidth = Math.ceil(width);

    return formattedWidth;
  }

  return (
    <div className="flex flex-col gap-2">
      <button
        className="bg-[var(--sky-primary)] px-3 py-1 rounded-lg text-white ml-auto"
        onClick={() => reactToPrintFn()}
      >
        Download PDF
      </button>

      <div style={{ display: "none" }}>
        <div ref={contentRef as never} style={{ padding: "1rem" }}>
          <table
            style={{
              width: "100vw",
              borderCollapse: "collapse",
            }}
          >
            <colgroup>
              {columns.map((column) => {
                const content = dataSource
                  .map((data) => data[column.key])
                  .join("");
                const widthContent = getTextWidth(content) || 0;

                const label = column.label || column.key;
                const widthLabel = getTextWidth(label) || 0;

                const width = Math.max(widthContent, widthLabel);

                return <col key={column.key} width={width} />;
              })}
            </colgroup>

            <tbody>
              {columns.map((column) => (
                <td
                  key={column.key}
                  style={{
                    borderBottom: "1px solid #e5e7eb",
                    borderCollapse: "collapse",
                    color: "#666",
                    textWrap: "nowrap",
                    padding: "0 1rem",
                  }}
                >
                  {column.label}
                </td>
              ))}

              {dataSource.map((data, idx) => (
                <tr key={idx}>
                  {columns.map((column) => {
                    const content = data[column.key] || "-";
                    let textAlign =
                      column.type !== "string" ? "center" : "left";
                    if (content === "-") textAlign = "center";

                    return (
                      <td
                        key={column.key}
                        style={{
                          borderBottom: "1px solid #e5e7eb",
                          borderCollapse: "collapse",
                          padding: "0 1rem",
                          textAlign: textAlign as never,
                        }}
                      >
                        {content}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <Table columns={columns} dataSource={dataSource} height={height} />
      </div>
    </div>
  );
};
